export default __webpack_public_path__ + "static/media/CrossIcon.e9689824.svg";